import React from 'react';
import {injectIntl} from 'react-intl';

const CheckboxField = ({intl, settings, onChange}) => {
  const {name, label, description, required = true, state, errors, labelAsMarkup = false} = settings || {};

  const renderDescription = () => {
    if (description) {
      return <div className="form-group__message">{intl.formatMessage({id: description})}</div>;
    }

    return '';
  };

  const renderErrors = () => {
    if (errors[name]) {
      return (
        <div className="form-group__feedback">
          {errors[name]}
        </div>
      );
    }

    return '';
  };

  const renderLabel = () => {
    if (label && labelAsMarkup) {
      return (
        <span
          className="selection-control__label"
          aria-hidden={true}
          dangerouslySetInnerHTML={{__html: intl.formatMessage({id: label})}} />
      );
    } else if (label) {
      return (
        <span className="selection-control__label" aria-hidden={true}>
          {intl.formatMessage({id: label})}
        </span>
      );
    }

    return '';
  };

  return (
    <div className={`form-group ${errors[name] ? 'form-group--error' : ''}`}>
      <div className="form-group__input form-group__input--checkbox">
        <label className="selection-control selection-control--checkbox">
          <span className="selection-control__input">
            <input name={name} type="checkbox" checked={state[name]} onChange={onChange} required={required}/>
            <span className="icon selection-control__control" aria-hidden={true}>
              <svg viewBox="0 0 16 16">
                <polyline points="2.1,8.5 6.2,12.4 13.9,5.1"/>
              </svg>
            </span>
          </span>
          {renderLabel()}
        </label>
      </div>
      {renderDescription()}
      {renderErrors()}
    </div>
  );
};

export default injectIntl(CheckboxField);
